<h1 class="title">{{'cart_detail.empty_cart_title' | translate}}</h1>
<ng-container *ngIf="isLoggedIn">
    <p class="text">{{'cart_detail.empty_cart_is_logged_in_text' | translate}}</p>
    <div class="buttons">
        <button  customButton
                 appearance="flat"
                 size="large"
                 expand="full"
                 [routerLink]="['/', routesNames.usualPurchase] | localize"
        >
            {{'cart_detail.empty_cart_usual_purchase' | translate}}
        </button>
        <button  customButton
                 appearance="ghost"
                 size="large"
                 expand="full"
                 [routerLink]="['/', routesNames.catalog] | localize"
        >
            {{'cart_detail.empty_cart_explore_button' | translate}}
        </button>
    </div>
</ng-container>

<ng-container *ngIf="!isLoggedIn">
    <p class="text">{{'cart_detail.empty_cart_text' | translate}}</p>
    <div class="buttons">
        <button
                customButton
                appearance="flat"
                size="large"
                expand="full"
                [routerLink]="['/', routesNames.login] | localize"
        >
            {{'cart_detail.empty_cart_log_in_button' | translate}}
        </button>
        <button
                customButton
                appearance="ghost"
                size="large"
                expand="full"
                [routerLink]="['/', routesNames.signUp] | localize"
        >
            {{'cart_detail.empty_cart_sign_up_button' | translate}}
        </button>
    </div>

</ng-container>

